import '@aofl/select';
import '@aofl/drawer';

export default (ctx, html) => html`
  <form id="payment-form-container" name="payment-form" @submit="${(e) => ctx.submitForm(e)}" novalidate>
    <fieldset class="cc-card-payment">
      <div class="input-container ${ctx.form.cardName.valid ? '' : 'is-invalid'}">
        <label id="card-name-label" class="cc-input-label" for="card-name" aria-hidden="true">Cardholder<span class="u-br"></span> Name</label>
        <div class="input-wrapper">
          <input id="card-name" type="text" name="card-name" @blur="${(e) => ctx.validateCardName(e)}" @input="${(e) => ctx.updateCardName(e)}" value="${ctx.cardName}" autocomplete="cc-name" aria-label="Enter the cardholder name." aria-describedby="card-name-error-message" aria-labelledby="card-name-label" required>
          ${ctx.form.cardName.valid ? '' : html`
            <span id="card-name-error-message" class="error-message" for="card-name" role="alert" aria-label="Error - Please enter a valid cardholder name.">Please enter a valid cardholder name.</span>
          `}
        </div>
      </div>
      <div class="input-container ${ctx.form.cardNumber.valid ? '' : 'is-invalid'}">
        <label id="cc-num-label" class="cc-input-label" for="cc-num" aria-hidden="true">Credit Card<span class="u-br"></span> Number</label>
        <div class="input-wrapper">
          <input id="cc-num" type="tel" name="cc-num" @blur="${(e) => ctx.validateCardNumber(e)}" @input="${(e) => ctx.updateCardNumber(e)}" value="${ctx.cardNumber}" autocomplete="cc-number" aria-label="Enter the credit card number." aria-describedby="cc-num-error-message" aria-labelledby="cc-num-label" required>
          ${ctx.form.cardNumber.isRequired.valid ? '' : html`
            <span id="cc-num-error-message" class="error-message" for="cc-num" role="alert" aria-label="Error - Please enter your credit card number.">Please enter the card number.</span>
          `}
          ${ctx.form.cardNumber.isNotZero.valid ? '' : html`
            <span id="cc-num-error-message" class="error-message" for="cc-num" role="alert" aria-label="Error - Please enter a valid credit card number.">Your card number is invalid.</span>
          `}
        </div>
      </div>
      <div class="input-container ${(ctx.form.expDate.valid && ctx.form.cardCvv.valid) ? '' : 'is-invalid'}">
        <label aria-hidden="true">Expiration<span class="u-br"></span> Date</label>
        <div id="dropdown-row">
          <div id="date-selector" class="${ctx.form.expDate.valid}">
            <div class="mkt-dropdown ${ctx.form.expDate.isNotExpired.valid ? '' : 'is-invalid'}" id="billing-info-month">
              <div class="dropdown-wrapper">
                <div class="button-wrapper enteractive ${ctx.form.expDate.isNotExpired.valid ? 'tab-outline-blue' : 'tab-outline-red'}" id="button-wrapper-month" @click="${(e) => ctx.toggleMonth(e)}" aria-label="Use the drop down to enter the month of the credit card expiration date." tabindex="0" aria-expanded="${ctx.ariaExpandedMonth}" role="button" aria-describedby="exp-date">
                  <div class="display-box">
                    <span>${ctx.cardMonth}</span>
                  </div>
                  <div aria-hidden="true" class="dropdown-arrow">
                    <span>&#9662;</span>
                  </div>
                </div>
                <aofl-drawer animate-drawer="false" ?open="${ctx.monthDropdownActive}">
                  <aofl-select-list id="select-list-month" @change="${(e) => ctx.updateCardMonth(e)}" role="listbox">
                    ${ctx.months.map((month) => html`
                      <aofl-list-option id="month-option" class="enteractive" value=${month} tabindex="0" role="listitem">${month}</aofl-list-option>
                    `)}
                  </aofl-select-list>
                </aofl-drawer>
              </div>
            </div>

            <div class="mkt-dropdown" id="billing-info-year">
              <div class="dropdown-wrapper">
                <div class="button-wrapper enteractive tab-outline-blue" @click="${(e) => ctx.toggleYear(e)}" aria-label="Use the drop down to enter the year of the credit card expiration date." tabindex="0" aria-expanded="${ctx.ariaExpandedYear}" role="button" aria-describedby="exp-date">
                  <div class="display-box">
                    <span>${ctx.cardYear}</span>
                  </div>
                  <div aria-hidden="true" class="dropdown-arrow">
                    <span>&#9662;</span>
                  </div>
                </div>
                <aofl-drawer animate-drawer="false" ?open="${ctx.yearDropdownActive}">
                  <aofl-select-list id="select-list-year" @change="${(e) => ctx.updateCardYear(e)}" role="listbox">
                    ${ctx.years.map((year) => html`
                      <aofl-list-option id="year-option" class="enteractive" value=${year} tabindex="0" role="listitem">${year}</aofl-list-option>
                    `)}
                  </aofl-select-list>
                </aofl-drawer>
              </div>
            </div>
          </div>
          ${ctx.form.expDate.isNotExpired.valid ? '' : html`
            <span class="error-message" for="exp-date" role="alert" aria-label="Error - Your expiration date is invalid.">Your expiration date is invalid.</span>
          `}
          <div id="cvv-wrapper" class="input-container">
            <div id="cvv-error-wrapper">
              <div class="error-wrapper ${ctx.form.cardCvv.valid ? '' : 'is-invalid'}">
                <label id="cvv-label" for="cvv" aria-hidden="true">CVV</label>
                <input id="cvv" type="tel" name="cvv" maxlength="4" @input="${(e) => ctx.updateCardCvv(e)}" value="${ctx.cardCvv}" @blur="${(e) => ctx.validateCardCvv(e)}" aria-label="Enter the CVV of the credit card." aria-describedby="cvv-error-message" aria-labelledby="cvv-label" required>
                ${ctx.form.cardCvv.isRequired.valid ? '' : html`
                  <span id="cvv-error-message" class="error-message empty-error ${ctx.form.cardCvv.isRequired.valid}" for="ccv" role="alert" aria-label="Error - Please enter your credit card security code.">Please enter security code.</span>
                `}
                ${ctx.form.cardCvv.isNotEmoji.valid && ctx.form.cardCvv.isNotZero.valid ? '' : html`
                  <span id="cvv-error-message" class="error-message invalid-error ${ctx.form.cardCvv.isRequired.valid}" for="ccv" role="alert" aria-label="Error - Please enter a valid credit card security code.">Your card security code is invalid.</span>
                `}
              </div>
              <button dom-scope="UJLWkMQg" id="cvv-button" class="button blue tab-outline-blue" type="button" @click="${(e) => ctx.showCvvPopup(e)}" role="alert" aria-label="What is the CVV and where is it located on my credit card.">?</button>
            </div>
          </div>
        </div>
      </div>
      <div id="zip-code-input-container" class="input-container ${ctx.form.zipCode.valid ? '' : 'is-invalid'}">
        <label id="zipcode-label" class="cc-input-label" for="zipcode" aria-hidden="true">Billing Zip/<span class="u-br"></span>Postal Code</label>
        <div class="input-wrapper">
          <input id="zipcode" type="tel" name="zipcode" @blur="${(e) => ctx.validateZipCode(e)}" @input="${(e) => ctx.updateZipCode(e)}" placeholder="Gift/International cards: enter 12345" value="${ctx.zipCode}" autocomplete="postal-code" aria-label="Enter your Billing Zip or Postal Code. For gift cards or international cards enter 12345." aria-describedby="zipcode-error-message" aria-labelledby="zipcode-label" required>
          ${ctx.form.zipCode.isRequired.valid ? '' : html`
            <span id="zipcode-error-message" class="error-message" for="zipcode" role="alert" aria-label="Error - Please provide your Billing Zip or Postal Code. For gift cards or international cards please enter 12345." >Please provide Zip or Postal Code.</span>
          `}
          ${ctx.form.zipCode.isNotZero.valid && ctx.form.zipCode.isNotEmoji.valid ? '' : html`
            <span id="zipcode-error-message" class="error-message" for="zipcode" role="alert" aria-label="Error - Please provide a valid Billing Zip or Postal Code. For gift cards or international cards please enter 12345.">Zip or Postal Code format you entered is invalid.</span>
          `}
        </div>
      </div>
      <div class="input-container">
        <label id="phone-number-label" class="cc-input-label" for="phone-number" aria-hidden="true">Phone Number</label>
        <div class="input-wrapper">
          <input id="phone-number" type="tel" name="phone-number" @input="${(e) => ctx.updatePhoneNumber(e)}" placeholder="Optional, but recommended" value="${ctx.phoneNumber}" autocomplete="tel" aria-labelledby="phone-number-label">
        </div>
      </div>
    </fieldset>
    <button dom-scope="ZF7TRMDr" id="payment-submit-button" type="submit" tabindex="-1" aria-hidden="true">Payment Submit Button</button>
  </form>
`;
